module.exports = __webpack_public_path__ + "img/chat-tool-active.4b8d05e6.svg";